var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMyPay(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "89px",
    height: "89px",
    viewBox: "0 0 89 89",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "MyPayslip") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0.3702 0.16 31.979 0.16 31.979 46.9995 0.3702 46.9995"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "MyPayslip",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(29.000000, 21.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.000000, 0.840100)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4222,39.8835 L15.5312,39.8835 C16.5412,37.9855 17.1142,35.8165 17.1142,33.5045 L17.1142,27.1395 L17.1142,20.0235 L17.1142,13.6415 C17.1142,10.1315 19.9702,7.2755 23.4812,7.2755 C25.4452,7.2755 27.0382,5.6825 27.0382,3.7175 C27.0382,1.7535 25.4452,0.1595 23.4812,0.1595 C16.0462,0.1595 9.9972,6.2085 9.9972,13.6425 L9.9972,20.0245 L9.9972,27.1395 L9.9972,33.5055 C9.9972,36.9695 7.2842,39.7685 3.8212,39.8735 C2.8802,39.9025 2.0432,40.3005 1.4242,40.9165 C1.4212,40.9205 1.4162,40.9235 1.4122,40.9285 C1.2662,41.0745 1.1382,41.2345 1.0192,41.4035 C1.0052,41.4245 0.9862,41.4425 0.9732,41.4625 C0.8702,41.6165 0.7862,41.7805 0.7082,41.9495 C0.6892,41.9935 0.6632,42.0335 0.6452,42.0765 C0.5812,42.2295 0.5392,42.3895 0.4962,42.5495 C0.4802,42.6185 0.4542,42.6855 0.4402,42.7575 C0.4132,42.8955 0.4062,43.0385 0.3982,43.1825 C0.3912,43.2695 0.3702,43.3535 0.3702,43.4425 C0.3702,43.4585 0.3762,43.4735 0.3762,43.4875 C0.3762,43.5055 0.3722,43.5225 0.3722,43.5395 C0.3762,43.6385 0.4002,43.7325 0.4112,43.8295 C0.4252,43.9575 0.4332,44.0895 0.4612,44.2125 C0.4762,44.2825 0.5032,44.3475 0.5232,44.4165 C0.5692,44.5755 0.6142,44.7345 0.6832,44.8825 C0.6932,44.9055 0.7052,44.9265 0.7172,44.9495 C1.2862,46.1575 2.5052,46.9995 3.9302,46.9995 L28.4222,46.9995 C30.3872,46.9995 31.9792005,45.4065 31.9792005,43.4425 C31.9802,41.4755 30.3882,39.8835 28.4222,39.8835",
    id: "Fill-1",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M23.5833,27.9614 L3.5413,27.9614 C1.5853,27.9614 0.0003,26.3764 0.0003,24.4194 C0.0003,22.4634 1.5853,20.8784 3.5413,20.8784 L23.5833,20.8784 C25.5393,20.8784 27.1253,22.4634 27.1253,24.4194 C27.1253,26.3764 25.5393,27.9614 23.5833,27.9614",
    id: "Fill-4",
    fill: "#FCBC00"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyPay);
export default __webpack_public_path__ + "static/media/my-pay.04ba478aaa8380bd89b5f905f7c89c40.svg";
export { ForwardRef as ReactComponent };